import { Directive, TemplateRef } from '@angular/core';
import { DatalistComponent } from './datalist.component';

@Directive({ selector: '[mriDataListSearch]', standalone: true })
export class DatalistSearchDirective {
  constructor(searchTemplate: TemplateRef<never>, datalist: DatalistComponent) {
    datalist.customSearchTemplate = searchTemplate;
  }
}
